import { Avatar, Card, CardActions, CardContent, CardHeader, Skeleton, Stack, useTheme } from '@mui/material';
import './CardInfo.scss';
import TypographyElement from '@/views/elements/typography/TypographyElement';

export default function SkeletonCardInfo() {
    const theme = useTheme()

    return (
        <Card
            className="card-info-user"
            sx={{
                width: 410,
                // minWidth: 368,
                // maxWidth: 410,
                bgcolor: theme.palette.background.default,
                position: 'relative',
                borderColor: theme.palette.border
            }}
            variant="outlined">

            <CardHeader
                avatar={
                    <Skeleton variant="rounded">
                        <Avatar sx={{}} aria-label="recipe" variant="rounded">
                            Loading
                        </Avatar>
                    </Skeleton>
                }
                sx={{ padding: 0 }}
                title={<Skeleton width="100%">
                    <TypographyElement>.</TypographyElement>
                </Skeleton>}
                subheader={<Skeleton width="100%">
                    <TypographyElement>.</TypographyElement>
                </Skeleton>}
            />

            <CardContent sx={{ px: 0, py: "10px" }}>
                <Stack direction={'row'} alignItems={"center"} justifyContent={"space-between"} spacing={1}>
                    <Skeleton width={"50%"} variant="rectangular" height={80} />
                    <Skeleton width={"50%"} variant="rectangular" height={80} />
                </Stack>

                <Stack direction={'row'} spacing={1}>
                    <Stack width={"100%"}>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                    </Stack>

                    <Stack width={"100%"}>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                    </Stack>

                    <Stack width={"100%"}>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                        <Skeleton width="100%">
                            <TypographyElement>.</TypographyElement>
                        </Skeleton>
                    </Stack>
                </Stack>
            </CardContent>

            <CardActions sx={{ px: 0, paddingBottom: 0 }}>
                <Stack spacing={2} sx={{ width: "100%" }} direction={"row"} justifyContent={"center"}>
                    <Skeleton width={"50%"} variant="rounded" height={36} />
                    <Skeleton width={"50%"} variant="rounded" height={36} />
                </Stack>
            </CardActions>

        </Card>
    )
}